// extracted by mini-css-extract-plugin
export default {"container":"IconBaner_container__KM0Oz","content":"IconBaner_content__2IFDn","img":"IconBaner_img__6foN4"};